// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallViewPopup__container-b4ff61 {
  display: flex;
  flex-direction: column;
  padding: 24px;
  flex: 1;
  overflow: hidden;
}

.ScheduledCallViewPopup__divider-f35b7a {
  margin: 8px 0;
  border-bottom: 1px solid var(--base-20);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduledCalls/ScheduledCallViewPopup/ScheduledCallViewPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,OAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  flex: 1;\n  overflow: hidden;\n}\n\n.divider {\n  margin: 8px 0;\n  border-bottom: 1px solid var(--base-20);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduledCallViewPopup__container-b4ff61`,
	"divider": `ScheduledCallViewPopup__divider-f35b7a`
};
module.exports = ___CSS_LOADER_EXPORT___;
